import { BehaviorSubject, catchError, map, Observable, of, tap } from "rxjs";
import { ExceptionService } from "src/app/core/exception.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Logger } from "src/app/core/logger";
import { Config } from "src/app/config";
import { FormTypeModel } from "src/app/models/api/form-type.model";
import { FormItemModel } from "src/app/models/api/form-item.model";
import { environment } from "src/environments/environment";
import { FormVersionModel } from "src/app/models/api/form-version.model";
import { ToastrService } from "ngx-toastr";
import { FormStatsModel } from "src/app/models/api/form-stats.model";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { WidgetsSectionModel } from "src/app/models/widgets/widgets-section.model";
import { WidgetsQuestionModel } from "src/app/models/widgets/widgets-question.model";

@Injectable({
  providedIn: 'root'
})
export class FormService {
  // Use the service as a state 
  public form$ = new BehaviorSubject({});

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService,
    private toastr: ToastrService,
    private logger: Logger
  ) {
  }

  /**
   * 
   * @returns Question Library to be loaded at startup to the palette
   */
  saveForm(survey): Observable<any> {
    const options = {
      headers: this.getHeaders(false, false)
    };

    // const url = environment.endpoints.saveForm;
    // const url = `${Config.app.projectApiUrl}/Form`;
    // let baseurl = environment.endpoints.projectApiUrl;
    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
    }
    const url = `${baseurl}/Form`;
    // return this.http.post(url, survey, options);
    return this.http
        .post(url, survey, options)
        .pipe(
          map( res => {
            this.logger.log('Response retrieved=' + res);
            return res;
          })
          // ,catchError(res => {
          //  return this.exceptionService.catchBadResponse(res);
          // }) 
          );      
  }

  addNewVersion(formId: number, serviceCode: string): Observable<any> {
    const options = {
      headers: this.getHeaders(false, false)
    };
    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
    }
    const url = `${baseurl}/Form/formversion`;
    return this.http
        .post(url, { FormId: formId, ServiceCode: serviceCode }, options)
        .pipe(
          map( res => {
            this.logger.log('Response retrieved=' + res);
            return res;
          }));      
  }

  getFormTypes() {
    const options = {
      headers: this.getHeaders(false, false)
    };

    // const url = `${Config.app.projectApiUrl}/FormType`;
    // const url = environment.endpoints.getFormTypes;
    // let baseurl = environment.endpoints.projectApiUrl;
    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
    }
    const url = `${baseurl}/FormType`;  
    return this.http.get<FormTypeModel[]>(url, options);
  }

  getForm(id): Observable<any> {
    const options = {
      headers: this.getHeaders(false, false)
    };

    // const url = environment.endpoints.getForm+"?FormId="+id;
    // const url = `${Config.app.projectApiUrl}/Form?FormId=${id}`;
    // let baseurl = environment.endpoints.projectApiUrl;
    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
    }
    const url = `${baseurl}/Form?FormId=${id}`;    
    return this.http.get<FormVersionModel[]>(url, options)
    .pipe(
      map( form => {
        // if (form) {
        //   // this.logger.log('Response retrieved with Id=' + form.toString());
        //   this.toastr.info('Form retrieved');
        // }
        return form;
      }),
      catchError(res => {
        if (res.status === 404) {
          const error = "Form retrieve error ["+res.status+"]: "+res.error;
          this.logger.warn(error);
          this.toastr.warning(error);
          return of(false);
        } if (res.status === 0 && res.error) {          
          this.logger.warn(res.message);
          this.toastr.warning(res.message);
          return of(false);
        }else {
          const error = "Form retrieve error ["+res.status+"]: "+res.error;
          this.logger.warn(error);
          this.toastr.warning(error);
          return of(false);          
          // return this.exceptionService.catchBadResponse(res);
        }
      }));         
  }  

  getAllForms(): Observable<any> {
    const options = {
      headers: this.getHeaders(false, false)
    };

    // const url = `${Config.app.projectApiUrl}/Form/forms`;
    // const url = environment.endpoints.getForms;
    // let baseurl = environment.endpoints.projectApiUrl;
    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
    }
    const url = `${baseurl}/Form/forms`;  
    return this.http.get<FormVersionModel[]>(url, options);    
  }
  
  public getHeaders(needId?: boolean, skipSpinner?: boolean): any {

    const uuid = (): string => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line: no-bitwise
      const r = (Math.random() * 16) | 0;
      // tslint:disable-next-line: no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });


    let headers = new HttpHeaders()
      .append('identity', Config.user.name)
      .append('Content-Type', 'application/json')
      .append('Accept', 'application/json');
    if (needId) {
      headers = headers.append('x-requestid', uuid());
    }

    if (skipSpinner) {
      headers = headers.append('skip-spinner', 'true');
    }
    return headers;
  }

  getFormStatistics(): Observable<any> {
    const options = {
      headers: this.getHeaders(false, false)
    };

    let baseurl = '';
    if (Config && Config.app) {
      baseurl = Config.projectApiUrl;
    }
    const url = `${baseurl}/Form/summary`;  
    return this.http.get<FormStatsModel[]>(url, options);    
  }

  extractQuestionsFromFormWidget(formData: WidgetsFormModel): WidgetsQuestionModel[] {
    const questionsWidgets: WidgetsQuestionModel[] = [];

    formData.children.forEach(section => {
      const sectionWidget = section as WidgetsSectionModel;
      const questionWidgets = sectionWidget.children as WidgetsQuestionModel[];
      questionsWidgets.push(...questionWidgets);

    });

    return questionsWidgets;
  
  }
  
}